import {DefaultTheme} from 'styled-components'

export const WORKSHOPS_BG_COLORS: Record<string, keyof DefaultTheme['colors']> = {
  'workshops-color-grey': 'workshopGray',
  'workshops-color-indigo': 'primaryIndigo',
  'workshops-color-blue': 'passionate',
  'workshops-color-pink': 'human',
  'workshops-color-red': 'bold',
  'workshops-color-yellow': 'outspoken',
} as const

export const isHighContrastColor = (color: keyof typeof WORKSHOPS_BG_COLORS): boolean => {
  const highContrastBgColors = [
    'workshops-color-indigo',
    'workshops-color-blue',
    'workshops-color-red',
  ]
  return highContrastBgColors.includes(color)
}
